module.exports = __webpack_public_path__ + "static/img/2.88068cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gczp/images/2.png
// module id = CZdP
// module chunks = 1